import { useState, useEffect } from 'react'
import Card, { CardHeader } from '../ui/Card'
import StatNumber from '../ui/StatNumber'
import SectionLabel from '../ui/SectionLabel'
import LoadingBear from '../ui/LoadingBear'
import { fetchMaintenance } from '../../api/client'

export default function MaintenancePanel() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchMaintenance().then(setData).finally(() => setLoading(false))
  }, [])

  if (loading) return <LoadingBear message="Checking the pipes..." />

  return (
    <div>
      <SectionLabel>Panel 7 — Maintenance</SectionLabel>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Card delay={0.05}>
          <StatNumber
            value={data?.unprocessed ?? '—'}
            label="Unprocessed"
            color={(data?.unprocessed ?? 0) > 100 ? 'persimmon' : 'gold'}
            size="md"
          />
        </Card>
        <Card delay={0.1}>
          <StatNumber value={data?.orphans ?? '—'} label="Orphans" color="parchment" size="md" />
        </Card>
        <Card delay={0.15}>
          <StatNumber value={data?.defaultPct ?? '—'} label="Default %" color="persimmon" size="md" />
        </Card>
        <Card delay={0.2}>
          <StatNumber value={data?.proposals ?? '—'} label="Proposals" color="sage" size="md" />
        </Card>
      </div>

      {/* Activity Heatmap placeholder */}
      <Card delay={0.25} className="mt-4">
        <CardHeader title="Activity Heatmap" />
        <div className="h-40 flex items-center justify-center rounded-lg bg-mm-parchment/[0.04]">
          <p className="text-mm-parchment/30 text-sm">Heatmap visualization — coming in Phase 4</p>
        </div>
      </Card>
    </div>
  )
}
